export class ApiFilesCoursesGet {
    region_id;
    budget_discipline_id: number;
    course_tag_id: number;
    order_direction;
    order_by;
    search;
    is_default;
    page:number;

    constructor(data) {
        this.region_id = data.region ? [data.region, 0] : null;
        this.course_tag_id = data.keyword? data.keyword : null;
        this.page = data.page ? data.page : 1;
    }
}